import styled from 'styled-components';

import { IconAIFilled } from '@xing-com/icons';
import { mediaTopBarHidden, mediaTopBarVisible } from '@xing-com/layout-tokens';
import {
  scale110,
  scale130,
  spaceM,
  spaceS,
  spaceXS,
  spaceXXL,
  xdlColorTextOnLight,
} from '@xing-com/tokens';
import { Hero } from '@xing-com/typography';

export const Container = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 800px;

  @media ${mediaTopBarHidden} {
    max-width: 648px;
    min-height: 371px;
  }
`;

export const FlagsContainer = styled.div`
  display: flex;
  margin-bottom: ${spaceM};
  gap: ${spaceXS};

  @media ${mediaTopBarVisible} {
    display: none;
  }
`;

export const Title = styled(Hero)`
  margin-bottom: ${spaceXXL};
  color: ${xdlColorTextOnLight};
  text-wrap: balance;

  @media ${mediaTopBarVisible} {
    margin-inline: 20px;
  }

  @media ${mediaTopBarVisible} {
    display: none;
  }
`;

export const Icon = styled(IconAIFilled)`
  transform: translateY(-${spaceS});
  height: ${scale110};

  @media ${mediaTopBarHidden} {
    height: ${scale130};
  }
`;
